
import { Vue, Component } from "vue-property-decorator";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import { UserModule } from "@/store/modules/user.store";

@Component({})
export default class CanMixin extends Vue {
  get ActionEnum() {
    return ActionEnum;
  }

  get ResourceEnum() {
    return ResourceEnum;
  }

  /**
   * checks if user is permitted to see the item
   *
   * @param item the item to check
   */
  isUserPermittedToSee(item: IMenuListItem) {
    if (!item.permission) {
      return true;
    }

    const { resource, action } = item.permission;

    return UserModule.abilities.can(action, resource);
  }
}
